import Axios from "axios";
import React, { useEffect, useContext } from "react";
import { useState } from "react";
import {  Link } from "react-router-dom";
import "./movie.scss";
import { BaseContext } from "../BaseContext";
import {
    message,
    Collapse,
    Table,
    Row,
    Col,
    Divider,
    Input,
    Space,
    Image,
    Button,
    Form,
    Select,
    Checkbox
} from "antd";
import {
    CheckCircleTwoTone,
    CloseCircleTwoTone,
    FilterOutlined,
    SearchOutlined,
    UndoOutlined,
    PlusOutlined,
} from "@ant-design/icons";

const Movie = () => {

    const { Column } = Table;
    const { Panel } = Collapse;
    const [filter] = Form.useForm();
    const [search] = Form.useForm();

    const { token, setToken, setUser, setEmail } = useContext(BaseContext);
    const [gameList, setGameList] = useState(null);
    const [filterList, setFilterList] = useState(null);

    const [filterRating, setFilterRating] = useState(undefined);
    const [genreList, setGenreList] = useState(null);
    const [platformList, setPlatformList] = useState(null);


    useEffect(() => {
        if (!gameList) {
            Axios.get("https://backendexample.sanbersy.com/api/data-game").then(
                (response) => {
                    setGameList(response.data);
                    // fetch genre from list 
                    let genreSet = new Set();
                    let platformSet = new Set();
                    response.data.forEach(({ genre, platform }) => {
                        if (genre) {
                            let itBe = genre.trim().replace(/,/gi, "^").split("^");
                            itBe.forEach((genre) => {
                                genreSet.add(genre);
                            });
                        }
                        if (platform) {
                            let itgo = platform.trim().replace(/,/gi, "^").split("^");
                            itgo.forEach((platform) => {
                                platformSet.add(platform.trim());
                            });
                        }


                    });

                  
                    setGenreList(genreSet);
                    setPlatformList(platformSet);

                }
            );
        }
    }, []);

    //   filter rating
    const onChangeFilterRating = (value) => {
        setFilterRating(value);
        filter.setFieldsValue({
            filterRating: value,
        });
    };

    // filter section
    const filterSearch = ({ filterGenre, filterPlatform, filterYear, filterMode }) => {


        let newList = gameList.filter((game) => {
            if (filterGenre && game.genre) {
                if (!game.genre.toLowerCase().includes(filterGenre.toLowerCase())) return false;
            }
            if (filterPlatform && game.platform) {
                if (!game.platform.toLowerCase().includes(filterPlatform.toLowerCase())) return false;
            }
            if (filterYear && game.release) {
                if (+game.release !== +filterYear) return false;
            }
            if (filterMode && filterMode.length > 0) {
                if (filterMode.includes('single')) {
                    if (+game.singlePlayer === 0) return false;
                }
                if (filterMode.includes('multi')) {
                    if (+game.multiplayer === 0) return false;
                }
            }
            return true;
        })
        setFilterList(newList);
    };


    const filterFailed = (err) => {
        setFilterList(null);
    };

    const resetSlider = () => {
        setFilterRating(undefined);
    };

    const searchFinish = ({ searchName }) => {

        if (searchName) {
            setFilterList(gameList.filter((game) => {
                if (game.name) {
                    return game.name.toLowerCase().includes(searchName.toLowerCase())
                }
                else {
                    return true;
                }
            }

            ))
        }
        else {
            setFilterList(null);
        }
    };
    const searchFailed = (err) => {
    };

    // handle table action

    const handleDelete = (id) => {
        Axios.delete(`https://backendexample.sanbersy.com/api/data-game/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setGameList(gameList.filter((val) => val.id !== id));
                message.success("Data Successfully deleted");
            })
            .catch((err) => {
                try {
                    if (err.response.data.status.includes('Token')) {
                        message.error('Token Expired , Please Log in Again!!');
                        setToken("");
                        setUser("");
                        setEmail("");
                        localStorage.removeItem("token");
                        localStorage.removeItem("user");
                        localStorage.removeItem("email");
                    }
                } catch (err) {
                    window.location.reload();
                    message.error(
                        "Error deleting data, if still insist refresh cache to start fresh ..."
                    );
                }
            });
    };



    return (
        <div
            style={{
                background: "#fff",
                width: "100%",
                borderRadius: ".6  rem",
                padding: "2% 1%",
            }}
        >

            {/* filter search new button */}

            <Collapse defaultActiveKey={1}
                expandIcon={({ isActive }) => (
                    <FilterOutlined rotate={isActive ? 90 : 0} />
                )}
                ghost
                className="collaps"
            >
                <Panel header="Filter Toggle" key="1" className="panell">
                    <Form
                        labelCol={{ span: 2 }}
                        wrapperCol={{ span: 4 }}
                        name="form"
                        initialValues={{ remember: true }}
                        form={filter}
                        onFinish={filterSearch}
                        onFinishFailed={filterFailed}
                    >
                        <Form.Item label="Genre" name="filterGenre">
                            <Select>
                                {genreList ?
                                    ([...genreList]).map(genre => {
                                        return (<Select.Option value={genre}>{genre}</Select.Option>)
                                    }) : ""
                                }

                            </Select>
                        </Form.Item>

                        <Form.Item label="Platform" name="filterPlatform">
                            <Select>
                                {platformList ?
                                    ([...platformList]).map(platform => {
                                        return (<Select.Option value={platform}>{platform}</Select.Option>)
                                    }) : ""
                                }

                            </Select>
                        </Form.Item>

                        <Form.Item label="Year" name="filterYear">
                            <Input type="number" min={1950} />
                        </Form.Item>
                        <Form.Item
                            label="Mode"
                            wrapperCol={{ span: 10 }}
                            name="filterMode"
                        >
                            <Checkbox.Group>
                                <Row>
                                    <Col >
                                        <Checkbox value="single" style={{ lineHeight: '32px' }}>
                                            Single Player
                                </Checkbox>
                                    </Col>

                                    <Col >
                                        <Checkbox value="multi" style={{ lineHeight: '32px' }}>
                                            Multi Player
                                    </Checkbox>
                                    </Col>

                                </Row>
                            </Checkbox.Group>
                        </Form.Item>

                        <Row style={{ marginBottom: "5vh" }}>
                            <Col offset={2}>
                                <Button htmlType="submit" style={{}}>
                                    <SearchOutlined style={{ color: "#14274e" }} /> Filter
                </Button>
                            </Col>
                            <Col>
                                <Button
                                    style={{
                                        margin: "0 8px",
                                    }}
                                    onClick={() => {
                                        filter.resetFields();
                                        resetSlider();
                                        setFilterList(null);
                                    }}
                                >
                                    <UndoOutlined /> Reset
                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Panel>
            </Collapse>

            {/* searchToggle */}
            <Collapse
                expandIcon={({ isActive }) => (
                    <SearchOutlined rotate={isActive ? 90 : 0} />
                )}
                ghost
                className="collaps"
            >
                <Panel header="Search Toggle" key="1" className="panell">
                    <Form
                        labelCol={{ span: 2 }}
                        wrapperCol={{ span: 4 }}
                        name="searchForm"
                        form={search}
                        initialValues={{ remember: true }}
                        onFinish={searchFinish}
                        onFinishFailed={searchFailed}
                    >
                        <Form.Item label="Search" name="searchName">
                            <Input placeholder="by name" />
                        </Form.Item>

                        <Row style={{ marginBottom: "5vh" }}>
                            <Col offset={2}>
                                <Button htmlType="submit" style={{}}>
                                    <SearchOutlined style={{ color: "#14274e" }} /> Search
                </Button>
                            </Col>
                            <Col>
                                <Button
                                    style={{
                                        margin: "0 8px",
                                    }}
                                    onClick={() => {
                                        search.resetFields();
                                        setFilterList(null);
                                    }}
                                >
                                    <UndoOutlined /> Reset
                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Panel>
            </Collapse>

            { gameList ? (
                <div>
                    <Divider orientation="center">Table Movies</Divider>
                    <row>
                        <Col style={{ marginLeft: "1vw" }}>
                            <Link to="/game/create"><Button type="primary" htmlType="submit">
                                <PlusOutlined /> Create New
              </Button>
                            </Link>
                        </Col>
                    </row>
                    <Table dataSource={filterList ? filterList : gameList}>
                        <Column
                            title="Image"
                            dataIndex="image_url"
                            key="image_url"
                            render={(image_url) => {
                                return (
                                    <Image
                                        width={150}
                                        src={image_url}
                                        style={{ cursor: "pointer" }}
                                    />
                                );
                            }}
                        />
                        <Column title="Title" dataIndex="name" key="name" sorter={(a, b) => {
                            if (a.title < b.title) { return -1; }
                            if (a.title > b.title) { return 1; }
                            return 0;
                        }}

                        />

                        <Column title="Year" dataIndex="release" key="release" sorter={(a, b) => a.year - b.year} />
                        <Column title="Genre" dataIndex="genre" key="genre" sorter={(a, b) => {
                            if (a.genre < b.genre) { return -1; }
                            if (a.genre > b.genre) { return 1; }
                            return 0;
                        }} />

                        <Column
                            title="Platform"
                            dataIndex="platform"
                            key="platform"
                            sorter={(a, b) => {
                                if (a.paltform < b.paltform) { return -1; }
                                if (a.paltform > b.paltform) { return 1; }
                                return 0;
                            }}
                        />

                        <Column
                            title="Single Player"
                            dataIndex="singlePlayer"
                            sorter={(a, b) => a.singlePlayer - b.singlePlayer}
                            render={(item) => {
                                if (item) {
                                    return <CheckCircleTwoTone twoToneColor="#2bf802" />
                                }
                                else {
                                    return <CloseCircleTwoTone twoToneColor="#f00d0d" />
                                }
                            }
                            }
                            key="singlePlayer"
                        />
                        <Column
                            title="Multi Player"
                            dataIndex="multiplayer"
                            sorter={(a, b) => a.singlePlayer - b.singlePlayer}
                            render={(item) => {
                                if (item) {
                                    return <CheckCircleTwoTone twoToneColor="#2bf802" />
                                }
                                else {
                                    return <CloseCircleTwoTone twoToneColor="#f00d0d" />
                                }
                            }
                            }
                            key="rating"
                        />
                        <Column
                            title="Action"
                            key="action"
                            render={(record) => (
                                <Space size="middle">
                                    <Link to={`/game/edit/${record.id}`}>
                                        <Button
                                            type="primary"
                                        >
                                            Edit
                  </Button>
                                    </Link>
                                    <Button
                                        type="primary"
                                        danger
                                        onClick={() => {
                                            handleDelete(record.id);
                                        }}
                                    >
                                        Delete
                  </Button>
                                </Space>
                            )}
                        />
                    </Table>
                </div>
            ) : (
                    ""
                )}
        </div>
    );
};

export default Movie;
